import React, {Component} from 'react'

import Content from '../Content'
import Item from '../Item'
import Link from '../Link'
import List from '../Lists'

class Rates extends Component {

  render () {

    const {
      entry
    } = this.props

    let type = entry.locationCategory

    if ( type == "park") {

      let rates = this.props.entry.rates

      const ratesList = rates.map( (rate) => {

        let hours = rate.time.replace(':', '')
        let cost = rate.cost

        return (
            <li className="List-item">

              <Item modifiers={['rates']}>

                  <div className="Item-head">
                     <Content modifier={'yellow'}>
                        <h4> {hours} </h4>
                    </Content>
                  </div>
                  <div className="Item-body">
                     <Content>
                        <h4> {cost} </h4>
                    </Content>

                  </div>

              </Item>

            </li>
          );

      })

      return (
        <div className="Template-section Template-section--narrow  Template-section--rates">

          <div className="Template-heading">
              <Content modifier={'alt'}>
                <h1>rates*</h1>
              </Content>
          </div>

          <div className="Template-content">

            <div className="Template-section-container">

              <List modifiers={['rates']}>

                  {ratesList}

              </List>

            </div>

            <Content html={entry.ratesText}/>

          </div>
        </div>
      )
    } else {
      return null;
    }
  }
}

export default Rates



// WEBPACK FOOTER //
// ./src/js/components/Rates/Rates.jsx